import React from "react";
import { LANG } from "../../translations/dynamic";
import { useSelector } from "react-redux";
const SortBy = (props) => {
 const {language} = useSelector((state)=>state.webApp)
  return (
    <div className="mt-3 mb-3 text-end">
      <label>
        <select
          id="sort_by"
          name="sort_by"
          type="text"
          className="form-select"
          aria-label="Sort by"
          onChange={props.sortingFun}
        >
          <option value="">{LANG.SORTBY[language]?.SORTBY}</option>
          <option value="HTL" data-id="monthlyPremium">{LANG.SORTBY[language]?.PHTL}</option>
          <option value="LTH" data-id="monthlyPremium">{LANG.SORTBY[language]?.PLTH}</option>
          <option value="HTL" data-id="pcpCopay">{LANG.SORTBY[language]?.PCPHTL}</option>
          <option value="LTH" data-id="pcpCopay">{LANG.SORTBY[language]?.PCPLTH}</option>
          <option value="HTL" data-id="specialistCopay">{LANG.SORTBY[language]?.SHTL}</option>
          <option value="LTH" data-id="specialistCopay">{LANG.SORTBY[language]?.SLTH}</option>
        </select>
      </label>
    </div>
  );
};
export default SortBy;
